module.exports = __webpack_public_path__ + "img/hospitium-09.552c25ca.jpg";